import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR, renderCargoTypes } from "../../../../../helpers/format";
import { IOperacaoPatioSPE } from "../types/types";

const statusMap: Record<number, string> = {
  0: "Programado",
  1: "Em Trânsito",
  2: "No Pátio",
  3: "Chamado",
  4: "Concluído",
  5: "Cancelado",
};

interface Props {
  data?: IOperacaoPatioSPE;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID Pátio SPE
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_operacao_patio_SPE ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Status
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.status !== undefined ? (statusMap[props.data.status] || String(props.data.status)) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data de Entrada
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_entrada ? formatDateTimeBR(props.data.data_entrada) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Placa Dianteira
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.placa_dianteira ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Tipo de Carga
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_carga ? String(renderCargoTypes(props.data.tipo_carga)) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID Agendamento Porto SPE
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_operacao_porto_agendada_SPE ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário Responsável
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ?? '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
